module.exports = __webpack_public_path__ + "static/ignasi-candela-82d87f6b70b84a49ca0cde20df3938d9.jpg";